import React from 'react';
import { styles } from './ProductCardDetails.css';
import { ProductCardDetailsType } from '../types';
import { getProductCardDetailsConfig } from './productCardDetailsConfig';

export const ProductCardDetails = ({ details, hasSiblings, productGroupId }: ProductCardDetailsType) => {
  if (!details || !productGroupId) return null;

  const productCardDetails = getProductCardDetailsConfig(productGroupId, details);
  if (!productCardDetails.details.length) return null;

  const variant = hasSiblings ? 'hasSiblings' : 'default';

  return (
    <ul
      className={styles.container[variant as keyof typeof styles.container]}
      data-group-id={productGroupId.toString()}
      data-product-type={productCardDetails.type}
      data-testid="product-card-detail-badges"
    >
      {productCardDetails.details.map(detail => (
        <li
          key={detail.accessibilityLabel}
          aria-label={detail.accessibilityLabel.toLowerCase()}
          className={styles.item}
          data-testid="product-card-detail-badge"
        >
          {detail.accessibilityLabel.length ? <span className={styles.label}>{detail.accessibilityLabel}</span> : null}
          <span>{detail.value}</span>
        </li>
      ))}
    </ul>
  );
};
